export default class CloseModal {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.modal.remove();
  }
}
